import React, {useContext} from "react";
import {observer} from "mobx-react";
import {Block, Typography} from "@bezlimit/bezlimit-ui";
import {useTranslation} from "react-i18next";
import "./style.scss";
import {LayoutContext} from "../../../../core/Contexts";
import _ from "lodash";
import {isIOS, isYandex, isSafari} from "react-device-detect";
import bgSpringIos from "../../../../images/lottery_spring_mob.gif";
import bgSpringYandex from "../../../../images/lottery_spring3.gif";
import {useNavigate} from "react-router-dom";

export const LotterySpring: React.FC = observer(() => {
    const {t} = useTranslation();
    const contextLayout = useContext(LayoutContext);
    const navigate = useNavigate();

    const onClick = () => {
        navigate("/lottery");
    };

    return (
        <Block className="bl-widget-spring" onClick={onClick}>
            <div className="vidContain">
                {_.lte(contextLayout?.width ?? 0, 769) || _.isEqual(isIOS, true) ? (
                    <img src={bgSpringIos} alt="" className="bl-widget-advertisement-is-ios" />
                ) : _.isEqual(isYandex, true) || _.isEqual(isSafari, true) ? (
                    <img src={bgSpringYandex} alt="" className="bl-widget-advertisement-is-ios" />
                ) : (
                    <video autoPlay muted loop>
                        <source src="lottery_spring-4.mp4" type="video/mp4" />
                    </video>
                )}
                {_.isEqual(isIOS, true) ||
                _.isEqual(isYandex, true) ||
                _.lte(contextLayout?.width ?? 0, 769) ||
                _.isEqual(isSafari, true) ? (
                    <Typography as="div" className="animation-text">
                        <span className="title">{t("РОЗЫГРЫШ \n24 МАЯ")}</span>
                        <span className="description"> {t("Призовой фонд")}</span>
                        <span className="prize"> {t("3 000 000")}</span>
                    </Typography>
                ) : null}
            </div>
        </Block>
    );
});
